import * as Yup from 'yup'

import { getCampaignBudget } from '../../../../Multiplatform/UploadAdCreative/ImpressionsBudgetSection/helpers'
import { formatCampaignName } from '../../../../Multiplatform/UploadAdCreative/UploadAdCreativeCampaignForm/Steps/CampaignNameStep/CampaignNameFields/helpers'

import {
  campaignObjectiveValidation,
  campaignValidation,
  getBudgetValidation,
  getCampaignInitialValues
} from '../../../../Multiplatform/UploadAdCreative/UploadAdCreativeCampaignForm/fields'
import { OBJECTIVE } from '../../../../Multiplatform/CampaignForms/fields'
import { DIGITAL_ALLOCATION_TYPE_IMPRESSIONS } from '../../../../Multiplatform/Partnerships/RightForms/fields'
import {
  ENGAGEMENT,
  LEAD_GENERATION,
  REACH,
  TRAFFIC,
  VIDEO_VIEWS,
  WEB_CONVERSIONS
} from '../../../../../constants/campaigns'

import { IMPRESSIONS } from '../../../../Multiplatform/UploadAdCreative/fields'
import { getImpressionsValidation } from '../../../../Multiplatform/UploadAdCreative/ImpressionsBudgetSection/validation'
import { LIST_ITEM_OPTION, OPTION_NEW_LIST_ITEM } from '../../../../../hooks/formHooks/listItemFormHooks/fields'

import { AUTO_OPTIMIZED_CAMPAIGN_BUDGET } from '../../../../reusableFields'
import { BUDGET_DAILY, BUDGET_LIFETIME, BUDGET_OPTION } from '../../../../Multiplatform/fields'

export const getInitialValues = ({ isCampaignsExist, rightAllocationType }) => {
  const campaignsInitialValues = getCampaignInitialValues(isCampaignsExist)

  return {
    ...campaignsInitialValues,
    [OBJECTIVE]: rightAllocationType === DIGITAL_ALLOCATION_TYPE_IMPRESSIONS ? REACH : '',
    [AUTO_OPTIMIZED_CAMPAIGN_BUDGET]: true,
    [BUDGET_OPTION]: BUDGET_LIFETIME,
    [BUDGET_LIFETIME]: '',
    [BUDGET_DAILY]: ''
  }
}

export const objectivesList = [
  {
    value: REACH,
    label: 'Reach'
  },
  {
    value: TRAFFIC,
    label: 'Traffic'
  },
  {
    value: VIDEO_VIEWS,
    label: 'Video Views'
  },
  {
    value: LEAD_GENERATION,
    label: 'Lead Generation'
  },
  {
    value: ENGAGEMENT,
    label: 'Engagement'
  },
  {
    value: WEB_CONVERSIONS,
    label: 'Web Conversions'
  }
]

export const getValidationSchema = ({
  remainingBudget,
  remainingImpressions,
  currencySymbol,
  allocationTypeImpressions
}) => {
  return Yup.object({
    ...campaignValidation,
    ...campaignObjectiveValidation,
    ...(allocationTypeImpressions
      ? {
          [IMPRESSIONS]: Yup.number().when([LIST_ITEM_OPTION, AUTO_OPTIMIZED_CAMPAIGN_BUDGET], {
            is: (listItemOption, autoOptimizedCampaignBudget) => {
              return listItemOption === OPTION_NEW_LIST_ITEM && autoOptimizedCampaignBudget
            },
            then: () =>
              Yup.number().when(OBJECTIVE, {
                is: value => value !== REACH,
                then: () => getImpressionsValidation({ remainingImpressions })
              })
          })
        }
      : {
          [BUDGET_LIFETIME]: Yup.number().when([LIST_ITEM_OPTION, BUDGET_OPTION, AUTO_OPTIMIZED_CAMPAIGN_BUDGET], {
            is: (listItemOption, campaignBudgetType, autoOptimizedCampaignBudget) => {
              return (
                listItemOption === OPTION_NEW_LIST_ITEM &&
                campaignBudgetType === BUDGET_LIFETIME &&
                autoOptimizedCampaignBudget
              )
            },
            then: () =>
              Yup.number().when(OBJECTIVE, {
                is: value => value !== REACH,
                then: () => getBudgetValidation({ remainingBudget, currencySymbol })
              })
          }),
          [BUDGET_DAILY]: Yup.number().when([LIST_ITEM_OPTION, BUDGET_OPTION, AUTO_OPTIMIZED_CAMPAIGN_BUDGET], {
            is: (listItemOption, campaignBudgetType, autoOptimizedCampaignBudget) => {
              return (
                listItemOption === OPTION_NEW_LIST_ITEM &&
                campaignBudgetType === BUDGET_DAILY &&
                autoOptimizedCampaignBudget
              )
            },
            then: () =>
              Yup.number().when(OBJECTIVE, {
                is: value => value !== REACH,
                then: () => getBudgetValidation({ remainingBudget, currencySymbol })
              })
          })
        })
  })
}

export const transformValuesToBE = ({ values, adAccountId, right, selectedPartnership }) => {
  const { allocation_type: rightAllocationType, bid_cap: rightBidCap } = right

  const autoOptimizedCampaignBudget = values[AUTO_OPTIMIZED_CAMPAIGN_BUDGET]
  const showBudgetSection = values[OBJECTIVE] !== REACH
  const includeBudgetInPayload = showBudgetSection && autoOptimizedCampaignBudget

  const campaignName = formatCampaignName(values, selectedPartnership)

  return {
    account: adAccountId,
    name: campaignName,
    objective: values[OBJECTIVE].toUpperCase(),
    ...(includeBudgetInPayload
      ? {
          ...(values[BUDGET_OPTION] === BUDGET_LIFETIME
            ? {
                budget: getCampaignBudget({ values, rightAllocationType, rightBidCap }),
                buying_type: 'BUDGET_MODE_TOTAL',
                budget_optimize_on: true
              }
            : {
                budget: getCampaignBudget({
                  values,
                  rightAllocationType,
                  rightBidCap,
                  budgetType: BUDGET_DAILY
                }),
                buying_type: 'BUDGET_MODE_DAY',
                budget_optimize_on: true
              })
        }
      : {
          buying_type: 'BUDGET_MODE_INFINITE'
        })
  }
}
